
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.98 21a1 1 0 110 2 1 1 0 010-2zm4.753-.136a1 1 0 11-1.854.75 1 1 0 011.854-.75zm-8.19-.546a1 1 0 11-.781 1.841 1 1 0 01.781-1.84zm-2.22-2.661a2 2 0 11-2.83 2.828 2 2 0 012.83-2.828zm13.434.707a1 1 0 11-1.414 1.414 1 1 0 011.414-1.414zM11.971 6.767a3.832 3.832 0 013.38 5.639l-.082.166-2.812 4.825a.54.54 0 01-.93.002l-2.855-4.827-.09-.183a3.832 3.832 0 013.39-5.623zm9.638 8.14a1 1 0 11-.782 1.84 1 1 0 01.782-1.84zm-17.948.53a1 1 0 11-1.841.78 1 1 0 011.84-.78zM21.979 11a1 1 0 110 2 1 1 0 010-2zm-20 0a1 1 0 110 2 1 1 0 010-2zm9.992-1.367a1.16 1.16 0 100 2.318 1.16 1.16 0 000-2.318zm10.174-1.834a1 1 0 11-1.854.749 1 1 0 011.854-.75zM3.131 7.253a1 1 0 11-.781 1.84 1 1 0 01.781-1.84zm17.333-3.738a2 2 0 11-2.828 2.828 2 2 0 012.828-2.828zm-14.849.707a1 1 0 11-1.414 1.414 1 1 0 011.414-1.414zM9.08 2.387a1 1 0 11-1.855.749 1 1 0 011.855-.75zm7.117-.546a1 1 0 11-.782 1.84 1 1 0 01.782-1.84zM11.979 1a1 1 0 110 2 1 1 0 010-2z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    